<script setup>
import { ref } from 'vue'

defineProps({
  name: {
    type: String,
    default: 'fileUpload'
  },
  acceptedFiles: {
    type: String,
    default: 'application/pdf, image/jpeg, image/png'
  },
  multiple: {
    type: Boolean,
    default: false
  },
  hidden: {
    type: Boolean,
    default: false
  },
  value: {
    type: Array,
    default: undefined
  }
})

const emit = defineEmits(['upload'])

const input = ref(null)

const fileUpload = event => {
  emit('upload', event.target.files)
}
const showFilePrompt = () => {
  input.value.click()
}

defineExpose({
  showFilePrompt
})
</script>

<template>
  <input
    ref="input"
    :name="name"
    :data-testid="name"
    type="file"
    :value="value"
    :multiple="multiple"
    :accept="acceptedFiles"
    :class="{ 'upload__input-hidden': hidden }"
    @change="fileUpload"
  />
</template>

<style lang="scss" scoped>
.upload__input-hidden {
  display: none;
}
</style>
